<script lang="ts">
  // BJL-CHECK: Button (used) — shared detail-sheet back affordance.
  import { Button } from '@byjackli-labs/ui/Button'
  import { BACK_ARROW_CHROME } from '../ui/theme'

  interface Props {
    onclick: () => void
    label: string
    style?: string
  }

  const { onclick, label, style = '' }: Props = $props()
</script>

<Button
  variant="text"
  size="sm"
  iconOnly
  {onclick}
  aria-label={label}
  title={label}
  style="{BACK_ARROW_CHROME} {style}"
>‹</Button>
